import React from 'react';

import useTranslate from '../../../../common/hooks/useTranslate';
import { useNavigate } from 'react-router-dom';

import { IAgreementsTable } from '../../types/IAgreementsTable';

import './agreementsTable.scss';

const AgreementsTable: React.FC<IAgreementsTable> = ({ agreements }) => {
  const { t } = useTranslate();
  const navigate = useNavigate();

  return (
    <div className='agreements-table'>
      {agreements && agreements.length < 1 &&
        <div className='agreement-item'>
          <span>{t('AGREEMENTS.NO_DOCUMENTS')}</span>
        </div>
      }
      {agreements &&
        agreements.map((agreement) => {
          return <div className='agreement-item pointer' onClick={() => navigate(`${agreement.id}`)}>
            <span>{agreement.name}</span>
          </div>;
        })
      }
    </div>
  );
};

export default AgreementsTable;
